export const STAGE_TYPE_INCOMING = 'INCOMING';
export const STAGE_TYPE_OUTGOING = 'OUTGOING';
export const STAGE_TYPE_BACKLOG = 'BACKLOG';
export const STAGE_TYPE_ATTESTATION = 'ATTESTATION';
